import type { FiQuestionnaireSystemTaskData, Group, MinifiedTask, QuestionnaireStatus } from '@gcv/shared';

import { getAssigneeName } from '../../tasks/util';
import { getEffectiveCompletedOn, hasPendingRevision } from '../questionnaire';

export const DEFAULT_ASSIGNEES_LABEL = 'Default assignees';

export interface QuestionnaireDrawerRow {
  assignee: string;
  completedOn: string;
  crbId: string;
  /** High fidelity sort key for matching up with overview */
  crbName_templateResultId: string;
  hasPendingRevision: boolean;
  hasRevisionHistory: boolean;
  name: string;
  status: QuestionnaireStatus;
  taskId: string;
  template_id: string;
  template_result_id: string;
}

/** One row per account a questionnaire distribution was sent to, sorted the way the overview is. */
export const getQuestionnaireDrawerRows = (
  groupedTasks: MinifiedTask[],
  bankGroups: Group[]
): QuestionnaireDrawerRow[] =>
  groupedTasks
    .map((task) => {
      const questionnaire = (task.data as FiQuestionnaireSystemTaskData).questionnaire_fi;
      const revisionHistory = questionnaire.revision_history;
      const hasExplicitAssignment = !!task.assigned_users?.length || !!task.assigned_group_ids?.length;
      const assignee = hasExplicitAssignment
        ? getAssigneeName(bankGroups, task.assigned_users, task.assigned_group_ids, task.assigned_groups)
        : '';
      const accountName = task.account?.name ?? '--';

      return {
        assignee: assignee || DEFAULT_ASSIGNEES_LABEL,
        completedOn: getEffectiveCompletedOn(revisionHistory, questionnaire.completed_on) ?? '',
        crbId: task.account?.id ?? '--',
        crbName_templateResultId: `${accountName}_${questionnaire.template_result_id}`,
        hasPendingRevision: hasPendingRevision(revisionHistory),
        hasRevisionHistory: (revisionHistory ?? []).length > 0,
        name: accountName,
        status: questionnaire.status,
        taskId: task.id,
        template_id: questionnaire.template_id,
        template_result_id: questionnaire.template_result_id
      };
    })
    .sort((a, b) =>
      a.crbName_templateResultId.toLowerCase() > b.crbName_templateResultId.toLowerCase() ? 1 : -1
    );
